import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Communication } from 'src/app/Modules/settings/models/profile/communication.model';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { AddUpdateCommunicationComponent } from '../add-update-communication/add-update-communication.component';
import { DatePipe } from '@angular/common';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-communications',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.scss'],
})
export class CommunicationsComponent implements OnInit, OnDestroy {
    @Input() profileSettingType: string;
    @Input() profileForm: UntypedFormGroup;
    @Input() set generalTabIndex(value) {
        if (value == 2) {
            this.globalEmittersService.addCommunication.next(true);
        } else {
            this.globalEmittersService.addCommunication.next(false);
        }
    }
    @ViewChild(MatPaginator) paginator: MatPaginator;
    destroy$ = new Subject();

    message: string;
    dataSource: MatTableDataSource<any>;
    communicationList: Communication[];
    communicationToBeSaved: Communication[];
    isCustomNotificationSaved: boolean;
    isSystemNotificationSaved: boolean;
    displayedColumns: string[] = ['title', 'message', 'notify from', 'notify until', 'communication type', 'action'];
    datePipe = new DatePipe('en');
    StateFormGroup: UntypedFormGroup;
    projectListmanage;
    stateOptions: any[];

    constructor(
        private globalEmittersService: GlobalEmittersService,
        private managementService: ManagementApiService,
        private userUtilityService: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private ngbModal: NgbModal,
        private customToastService: CustomToastService,
        private fb: UntypedFormBuilder,
        private idmsSharedService: IdmsSharedService,
        private transLocoService: TranslocoService
    ) {
        this.message = '';
        this.communicationToBeSaved = [];
        this.isSystemNotificationSaved = false;
        this.isCustomNotificationSaved = false;
        this.projectListmanage = 'Active';
        this.stateOptions = [
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ACTIVE'), value: 'Active' },
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMPLETED'), value: 'Completed' },
        ];
    }

    ngOnInit(): void {
        this.StateFormGroup = this.fb.group({
            status: [this.projectListmanage],
        });
        this.profileForm.addControl('communication', new UntypedFormControl('', []));
        this.getCommunication();
        this.globalEmittersService.addCommunicationEvent.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.communicationList.push(res);
                this.communicationToBeSaved.push(res);
                this.dataSource = new MatTableDataSource(this.communicationList);
                this.dataSource.paginator = this.paginator;
                this.ngbModal.dismissAll();
                if (this.communicationToBeSaved.length > 0) {
                    this.profileForm.get('communication').markAsDirty();
                } else {
                    this.profileForm.get('communication').reset();
                }
                this.customToastService.successToast(this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_ADDED_SUCCESSFULLY'), 'Success');
            }
        });

        this.globalEmittersService.getCommunicationListSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.getCommunication();
            }
        });

        this.StateFormGroup.get('status')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) this.getCommunication();
            });
    }

    // * search handler
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        let searchList = [];
        searchList = this.communicationList.filter((item) => {
            return (
                (item.message !== undefined ? item.message : '').toLowerCase().trim().includes(filterValue.toLowerCase().trim()) ||
                (item.title !== undefined ? item.title : '').toLowerCase().trim().includes(filterValue.toLowerCase().trim()) ||
                (item.startDate !== undefined ? item.startDate : '').toLowerCase().trim().includes(filterValue.toLowerCase().trim()) ||
                (item.endDate !== undefined ? item.endDate : '').toLowerCase().trim().includes(filterValue.toLowerCase().trim())
            );
        });
        this.dataSource = new MatTableDataSource(searchList);
        this.paginator.firstPage();
        this.dataSource.paginator = this.paginator;
    }

    // * api to get the communication list
    getCommunication() {
        let status = this.StateFormGroup.get('status').value == 'Active' ? true : false;
        this.ngxUiLoaderService.start();
        this.managementService.getCommunicationList(status).subscribe((res) => {
            this.ngxUiLoaderService.stop();
            if (res.success) {
                this.isCustomNotificationSaved = false;
                this.isSystemNotificationSaved = false;
                this.globalEmittersService.communicationList.next(res.response);
                this.communicationList = res.response;

                this.communicationList.forEach((communication) => {
                    // if(communication.)
                    // TODO Need to update the "isSystemNotification" property
                    if (communication.notificationCheckType === 5) {
                        let placeHolderObj = JSON.parse(communication.placeHolder);
                        const startDate = new Date(placeHolderObj.startdate).toLocaleString();
                        const endDate = new Date(placeHolderObj.enddate).toLocaleString();
                        communication.systemStartDate = placeHolderObj.startdate;
                        communication.systemEndDate = placeHolderObj.enddate;
                        communication.message = `MAINTENANCE: Please be advised that there will be scheduled downtime across our applications from ${startDate} to ${endDate} for system maintenance. We apologize for any inconvenience.`;
                    } else {
                        communication.messageForDisplay = this.removeHTMLTags(communication.message);
                    }
                });
                this.dataSource = new MatTableDataSource(this.communicationList);
                this.dataSource.paginator = this.paginator;
            } else {
                this.userUtilityService.errorModelPopup(res.message);
            }
        });
    }

    // * display notification types
    displayNotificationTypes(notificationType: Array<number>) {
        let result = '';
        switch (notificationType.length) {
            case 1:
                if (notificationType[0] == 1) {
                    result = `Email`;
                } else if (notificationType[0] == 2) {
                    result = `Mobile`;
                } else if (notificationType[0] == 4) {
                    result = `Web`;
                }
                break;
            case 2:
                // let result;
                if (notificationType[0] + notificationType[1] === 3) {
                    result = `Email, Mobile`;
                } else if (notificationType[0] + notificationType[1] === 5) {
                    result = `Email, Web`;
                } else if (notificationType[0] + notificationType[1] === 6) {
                    result = `Mobile, Web`;
                }
                break;
            case 3:
                result = `Email, Mobile, Web`;
                break;
        }
        return `${result} Notification`;
    }

    // * api call to save custom notifications
    // * api call to save custom notifications
    saveCustomNotifications(customNotification: Communication[]): void {
        // * formate the date
        customNotification.forEach((res) => {
            const startDatePipe = new DatePipe('en');
            const endDatePipe = new DatePipe('en');
            res.startDate = startDatePipe.transform(res.startDate, 'MM/dd/yyyy');
            res.endDate = endDatePipe.transform(res.endDate, 'MM/dd/yyyy');
        });
        this.ngxUiLoaderService.start();
        this.managementService.saveCommunication(customNotification).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    this.customToastService.successToast(
                        this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_SAVED_SUCCESSFULLY'),
                        'Success'
                    );

                    this.globalEmittersService.getCommunicationListSubject.next(true);
                } else if (res.isCustom) {
                    this.userUtilityService.errorModelPopup(res.message);
                }
            },
            (err) => this.ngxUiLoaderService.stop()
        );
    }
    // * delete communication list
    deleteCommunicationList(communication: Communication) {
        let dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
        });
        let index = this.communicationList.findIndex((item) => item.title == communication.title);
        let subIndex = this.communicationToBeSaved.findIndex((item) => item.title == communication.title);
        dialogRef.componentInstance.modalMessage = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NOTIFICATION');
        dialogRef.result
            .then((res) => {
                if (res) {
                    if (communication.notificationTemplateId) {
                        this.deleteCommunication([{ notificationTemplateId: communication.notificationTemplateId, active: false }]);
                        this.communicationList.splice(index, 1);
                    } else {
                        this.communicationList.splice(index, 1);
                        this.customToastService.successToast(
                            this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_DELETED_SUCCESSFULLY'),
                            'Success'
                        );
                    }
                    if (subIndex != -1) {
                        this.communicationToBeSaved.splice(subIndex, 1);
                    }

                    this.dataSource = new MatTableDataSource(this.communicationList);
                    this.dataSource.paginator = this.paginator;
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * api to delete communication
    deleteCommunication(payload) {
        this.ngxUiLoaderService.start();
        this.managementService
            .saveCommunication(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        this.customToastService.successToast(
                            this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.NOTIFICATION_DELETED_SUCCESSFULLY'),
                            'Success'
                        );
                    } else if (res.isCustom) {
                        this.customToastService.successToast(
                            this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ERROR_WHILE_DELETE_THE_NOTIFICATION'),
                            'Error'
                        );
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    // * get formatted date
    getFormatedDate(date) {
        return this.idmsSharedService.formatDateCustom(new Date(date)); //new Date(date).toLocaleDateString() == 'Invalid Date' ? '-' : new Date(date).toLocaleDateString();
    }

    // * helper method to add general notification
    generalNotificationAdd(communication: Communication, modalType: number): void {
        const dialogRef = this.ngbModal.open(AddUpdateCommunicationComponent, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.communication = communication;
        dialogRef.componentInstance.modalType = modalType;
        if (communication.notificationCheckType == 5) {
            dialogRef.componentInstance.isGeneralNotification = false;
        } else {
            dialogRef.componentInstance.isGeneralNotification = true;
        }
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.saveCustomNotifications([res.communication]);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * helper method to add maintenance notification
    maintenanceNotificationAdd(): void {
        const dialogRef = this.ngbModal.open(AddUpdateCommunicationComponent, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.communication = null;
        dialogRef.componentInstance.isGeneralNotification = false;
    }

    // @HostListener('window:beforeunload')
    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (this.profileForm.dirty) {
            $event.returnValue = 'Your data will be lost!';
            return void 0;
        }
    }

    removeHTMLTags(htmlString) {
        return htmlString.replace(/<[^>]*>/g, '');
    }

    ngOnDestroy(): void {
        this.globalEmittersService.addCommunication.next(false);
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
